import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Pill.module.css';

const Pill = ({
  color,
  text,
  shape = 'pill',
  marginLeft = null,
  marginRight = null
}) => (
  <span
    style={{ marginLeft, marginRight }}
    styleName={classNames(shape, color, {
      long: text.length > 2
    })}
  >
    {text}
  </span>
);

Pill.propTypes = {
  color: PropTypes.oneOf(['blue', 'light-blue', 'light-grey', 'black', 'red']),
  type: PropTypes.oneOf(['pill', 'circle']),
  text: PropTypes.string,
  marginLeft: PropTypes.string,
  marginRight: PropTypes.string
};

export default Pill;
